import { useTranslation } from "react-i18next";
import { ArrowLeftOutlined, CloseOutlined, InfoCircleOutlined, } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, message, Radio, RadioChangeEvent, Row, Space, Typography, } from "antd";
import React, { useEffect, useState } from "react";
import {
  getSectionDetail,
  getSquenceDetail,
  postCreateSection,
  postCreateSequence,
  putCourseUpdateSection,
  putCourseUpdateSequence,
} from "../../../service/course-construct";
import FormInput from "../../form-input/FormInput";
import CommonModal from "../../modal/common";
import "./addChapter.scss";
import { globalStore } from "../../../stores/stores";

type Props = {
  open?: boolean;
  isLesson?: boolean;
  title?: string;
  setIsOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  id?: number;
  handleDetail?: any;
  itemDetail?: any;
  isEdit?: boolean;
  sectionDetail?: any;
  setIsLesson?: (value: boolean) => void
};

const AddChapter = (props: Props) => {
  const { t } = useTranslation();
  const {
    open,
    setIsOpenDrawer,
    id,
    handleDetail,
    isLesson,
    isEdit,
    itemDetail,
    setIsLesson
  } = props;
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [titleContent, setTitleContent] = useState<string>("");
  const [describe, setDescribe] = useState<string>("");
  const [availableStatus, setAvailableStatus] = useState(0);
  const [sectionDetail, setSectionDetail] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const { reload, setReload } = globalStore()

  const getSectionDetailApi = async () => {
    const apiParams = isLesson ? getSquenceDetail : getSectionDetail;
    await apiParams(Number(itemDetail?.id)).then((res) => {
      if (res.status === 200) {
        setSectionDetail(res.data);
      }
    });
  };

  useEffect(() => {
    if (isEdit) {
      getSectionDetailApi();
    } else {
      form.resetFields()
    }
  }, [open, isLesson]);

  useEffect(() => {
    form.setFieldValue("roleNames", sectionDetail?.name)
    form.setFieldValue("describe", sectionDetail?.description)
    setTitleContent(sectionDetail?.name);
    setDescribe(sectionDetail?.description);
    setAvailableStatus(sectionDetail?.availableStatus ?? 0);
  }, [sectionDetail]);

  const onCloseDraw = () => {
    setStep(1);
    form.resetFields();
    setIsOpenDrawer(false);
    setTitleContent("");
    setDescribe("");
    setSectionDetail(null)
    if (setIsLesson) {
      setIsLesson(false)
    }
  };
  const onCloseModal = () => {
    setIsOpen(false);
  };
  const handleRadioChange = (e: RadioChangeEvent) => {
    setAvailableStatus(e.target.value);
  };
  const renderNameDraw = () => {
    if (isLesson) {
      return isEdit ? t("Sửa bài giảng", "Sửa bài giảng") : t("Thêm bài giảng", "Thêm bài giảng");
    } else return isEdit ? t("Sửa chương", "Sửa chương") : t("Thêm chương", "Thêm chương");
  };
  const handleAddSection = async () => {
    const params = {
      name: titleContent,
      description: describe,
      availableStatus: availableStatus,
    };
    const submitApiUrl = () => {
      setLoading(true);

      if (isLesson) {
        if (isEdit) {
          return putCourseUpdateSequence({
            ...params,
            sectionId: id,
            id: Number(itemDetail?.id),
          });
        } else
          return postCreateSequence({
            ...params,
            sectionId: itemDetail?.id,
          });
      } else {
        if (isEdit) {
          return putCourseUpdateSection({
            ...params,
            sectionId: itemDetail?.id,
          });
        } else
          return postCreateSection({
            ...params,
            courseId: id,
          });
      }
    };

    try {
      await submitApiUrl().then((result: any) => {
        handleDetail && handleDetail();
        onCloseModal();
        onCloseDraw();
        setReload(!reload)
        setIsOpenDrawer(false)
        message.success(renderNameDraw() + " thành công");
      });
    } catch (error) {
    }
    finally {
      setLoading(false)
    }
  };

  const radioItemList = [
    {
      value: 0,
      title: t("Bản nháp", "Bản nháp"),
      describe: t("Mặc định khi khởi tạo. Người học sẽ không thể tìm kếm hoặc nhìn thấy nội dung này ở trên nền tảng.", "Mặc định khi khởi tạo. Người học sẽ không thể tìm kếm hoặc nhìn thấy nội dung này ở trên nền tảng."),
    },
    {
      value: 1,
      title: t("Riêng tư", "Riêng tư"),
      describe: t("Nội dung chỉ hiển thị với những Người học được Giảng viên đăng ký hoặc Người học đã trả phí.", "Nội dung chỉ hiển thị với những Người học được Giảng viên đăng ký hoặc Người học đã trả phí."),
    },
    {
      value: 2,
      title: t("Công khai", "Công khai"),
      describe: t("Nội dung được hiển thị công khai trên danh sách nội dung học và Người học có thể tìm kiếm, học nội dung.", "Nội dung được hiển thị công khai trên danh sách nội dung học và Người học có thể tìm kiếm, học nội dung."),
    }
  ];
  const renderAddChapterS1 = () => {
    return (
      <>
        <Form.Item
          label={`${"Tiêu đề " + (isLesson ? t("bài giảng", "bài giảng") : t("chương", "chương"))}`}
          name="roleNames"
          rules={[
            {
              required: true,
              message: t("Thông tin này bắt buộc", "Thông tin này bắt buộc"),
            },
          ]}
        >
          <FormInput
            placeholder={t("Nhập tiêu đề", "Nhập tiêu đề")}
            value={titleContent}
            onChange={(e) => setTitleContent(e.target.value)}
          />
        </Form.Item>
        <div className="add-chapter-describe">
          {t("Hãy đặt tên ngắn gọn, cung cấp thông tin và hấp dẫn", "Hãy đặt tên ngắn gọn, cung cấp thông tin và hấp dẫn")}
        </div>
        <Form.Item label={t("Mô tả", "Mô tả")} name="describe">
          <Input.TextArea
            placeholder={t("Nhập mô tả", "Nhập mô tả")}
            autoSize={{ minRows: 6 }}
            value={describe}
            onChange={(e) => setDescribe(e.target.value)}
          />
        </Form.Item>
        <div className="add-chapter-describe">
          {t("Cung cấp mô tả ngắn gọn cho phần này", "Cung cấp mô tả ngắn gọn cho phần này")}
        </div>
        <div className="add-chapter-btn">
          <Space>
            <Button className="btn btn-primary" onClick={() => form.submit()}>
              <Typography.Text>{t("Tiếp tục", "Tiếp tục")}</Typography.Text>
            </Button>
            <Button onClick={onCloseDraw} className="btn btn-outlined">
              <CloseOutlined />
              <Typography.Text>{t("Đóng", "Đóng")}</Typography.Text>
            </Button>
          </Space>
        </div>
      </>
    );
  };
  const renderAddChapterS2 = () => {
    return (
      <>
        <Row>
          <Col span={12}>
            <Typography.Title className="add-chapter-title" level={5}>
              {t("Truy cập", "Truy cập")}
            </Typography.Title>
            <span className="add-chapter-describe">
              Thiết lập tính khả dụng của phần này. Bản nháp là chế độ mặc định
              (chưa xuất bản và không hiển thị) để có thời gian phát triển nội
              dung của bạn
            </span>
          </Col>
          <Col span={12}>
            <Radio.Group value={availableStatus} defaultValue={availableStatus} onChange={handleRadioChange}>
              {radioItemList.map((item, index) => (
                <div key={index} className="radio-item wrapper-radio">
                  <Radio value={item.value}>
                    <Typography.Title className="add-chapter-title" level={5}>
                      {item.title}
                    </Typography.Title>
                  </Radio>
                  <div className="add-chapter-describe">{item.describe}</div>
                </div>
              ))}
            </Radio.Group>
          </Col>
        </Row>
        <div className="add-chapter-confirm">
          <Space>
            <ArrowLeftOutlined />
            <div className="add-chapter-back" onClick={() => setStep(1)}>
              <Typography.Text>{t("Bước trước", "Bước trước")}</Typography.Text>
            </div>
          </Space>

          <Space>
            <Button className="btn btn-primary" onClick={() => setIsOpen(true)}>
              <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
            </Button>
            <Button onClick={onCloseDraw} className="btn btn-outlined">
              <CloseOutlined />
              <Typography.Text>{t("Đóng", "Đóng")}</Typography.Text>
            </Button>
          </Space>
        </div>
      </>
    );
  };
  return (
    <Form.Provider onFormFinish={(name, { values, forms }) => {
      if (name === 'add-chapter') {
        setStep(2)
      }
    }}>
      <Drawer
        title={`${renderNameDraw()} ${isEdit ? sectionDetail?.name : ""}`}
        onClose={onCloseDraw}
        open={open}
        width={736}
        maskClosable={false}
      >
        <Form
          className="add-chapter"
          layout={"vertical"}
          form={form}
          name="add-chapter"
        >
          {step === 1 ? renderAddChapterS1() : renderAddChapterS2()}
        </Form>
        <CommonModal
          open={isOpen}
          title={`Thông báo xác nhận lưu ${isLesson ? t("bài giảng", "bài giảng") : t("chương", "chương")}`}
          desc={
            <>
              <p>{t("Xin vui lòng xác nhận việc lưu", "Xin vui lòng xác nhận việc lưu")} {`${isLesson ? t("bài giảng", "bài giảng") : t("chương", "chương")}`} {t("trong khoá học", "trong khoá học")}</p>
              <div>
                {t("Đảm bảo rằng tất cả các", "Đảm bảo rằng tất cả các")}{" "}
                <span className="text-browse">
                  {t("thông tin liên quan đã được kiểm tra và cập nhật đầy đủ", "thông tin liên quan đã được kiểm tra và cập nhật đầy đủ")}{" "}
                </span>
                {t("trước khi lưu", "trước khi lưu")} {`${isLesson ? t("bài giảng", "bài giảng") : t("chương", "chương")}`}
              </div>
            </>
          }
          closeIcon={true}
          loading={loading}
          okText={t("Xác nhận", "Xác nhận")}
          cancelText={t("Huỷ", "Huỷ")}
          icon={
            <InfoCircleOutlined
              style={{ color: "#FFC53D", marginRight: "10px" }}
            />
          }
          confirm={handleAddSection}
          closeModal={onCloseModal}
          className={""}
        />
      </Drawer>
    </Form.Provider>
  );
};

export default AddChapter;

interface ItemDetail {
  name: string;
  describe: string;
  id: number;
}
